"use client";

import { FieldContainer } from "./FieldContainer";
import { useFieldContext } from "../hooks/form-context";
import { Checkbox } from "@ui/components/core/Checkbox";
import { useTranslations } from "next-intl";

export interface FormCheckboxProps {
  name: string;
  label: React.ReactNode;
  required?: boolean;
}

/**
 * Form-connected Checkbox that integrates with TanStack Form via `useFieldContext`.
 * Follows the same error-display pattern as Input and Textarea.
 */
export const FormCheckbox = ({ name, label, required }: FormCheckboxProps) => {
  const field = useFieldContext();
  const t = useTranslations("ClientKeys.contact_sales_page.form");

  return (
    <FieldContainer>
      <div className='tw-flex tw-items-start tw-gap-2'>
        <div className='tw-pt-0.5'>
          <Checkbox
            id={name}
            name={name}
            isRequired={required}
            isSelected={field.state.value as boolean}
            onChange={value => field.handleChange(value)}
            size='lg'
          />
        </div>
        <label htmlFor={name} className='tw-type-2xs tw-text-black/60 tw-p-0.5 tw-cursor-pointer'>
          {label}
          {!required && (
            <span className='tw-text-[0.75rem] tw-text-black tw-opacity-40'> ({t("labels.optional")})</span>
          )}
        </label>
      </div>
    </FieldContainer>
  );
};
